import React, { useState } from 'react';
import { connect } from 'react-redux';
import BuyModalSC from './buy-modal.styled';
import { HeadingTwo, SmallText } from '../../typography';
import InlineLoading from '../../ui/inline-loading';
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';
import dlt from '../../../utils/default-lang';
import Button from '../../ui/button';
import numeral from 'numeral';
import { useEffect } from 'react';
// import DocumentCheck from '../../ui/document-check';
import SummaryTable from '../components/summary-table';
import BalanceAlert from '../../balance-alert';

const BuyModal = ({ balance, type, offerDetail, onSubmit, instruction, isBiddingTable }) => {
  const [isError, setIsError] = useState(false);
  const free = Number(balance?.free || 0);
  const tied = Number(balance?.tied || 0);
  const reserved = Number(offerDetail.reserved_resources || 0);
  console.log(offerDetail);

  const freeResources =
    type === 'secondary-market'
      ? Number(free + tied + reserved) >= Number(offerDetail.price)
      : Number(free + tied + reserved) >= Number(offerDetail.seller_last_bid);

  const nonReinvestFunds =
    Number(offerDetail.price) !== '' && Number(Number(offerDetail.price)).toFixed(2) > free;

  /*  const [isDocumentChecked, setIsDocumentChecked] = useState(false);
  const generatedDocument = {
    url: 'https://www.wishmaker.sk/static/pdf/vseobecne_obchodne_podmienky.pdf',
    title: 'Súhlas s poskytnutím služby',
  };

  const checkDocument = (docLink) => {
    window.open(`${docLink}`);
    setIsDocumentChecked(true);
  }; */
  const balanceError = React.useMemo(() => {
    if (!freeResources) {
      return (
        <BalanceAlert
          type="error"
          description={
            <FormattedMessage
              id="investor_secondary_market_resources_error_headline"
              defaultMessage={dlt['investor_secondary_market_resources_error_headline']}
            />
          }
        />
      );
    } else if (nonReinvestFunds) {
      return (
        <BalanceAlert
          type="warning"
          description={
            <FormattedMessage
              id="investor_secondary_market_modal_error_free_resources"
              defaultMessage={dlt['investor_secondary_market_modal_error_free_resources']}
            />
          }
        />
      );
    }

    return null;
  }, [freeResources, nonReinvestFunds]);

  useEffect(() => {
    if (instruction.interestRate > Number(offerDetail.interestRate) * 100) {
      setIsError(true);
    } else {
      setIsError(false);
    }
  }, [instruction, offerDetail]);

  if (offerDetail === null || Object.keys(offerDetail).length < 1) {
    return (
      <BuyModalSC>
        <div className="modal-loading-wrap">
          <InlineLoading />
        </div>
      </BuyModalSC>
    );
  }
  return (
    <BuyModalSC>
      <div className="top-text-wrap">
        <HeadingTwo className="bold">
          <FormattedMessage
            id="investor_secondary_market_buy_modal_headline"
            defaultMessage={dlt['investor_secondary_market_buy_modal_headline']}
          />
        </HeadingTwo>
      </div>

      <div className="price-wrap">
        <h2>{numeral(Number(offerDetail.price)).format('0,00.00')} €</h2>
        <SmallText className="bolder black-transparent-lighter">
          <FormattedMessage
            id="investor_secondary_market_buy_modal_price"
            defaultMessage={dlt['investor_secondary_market_buy_modal_price']}
          />
        </SmallText>
      </div>

      <SummaryTable offerDetail={offerDetail} isBiddingTable={isBiddingTable} />

      {isError ? (
        <BalanceAlert
          description={
            <FormattedHTMLMessage
              id="investor_secondary_market_buy_modal_error_rate"
              defaultMessage={dlt['investor_secondary_market_buy_modal_error_rate']}
              values={{
                loanRate: numeral(Number(offerDetail.interestRate) * 100).format('0.[00]'),
                investorRate: instruction.interestRate,
              }}
            />
          }
        />
      ) : null}

      {balanceError}

      <div className="submit-wrap">
        <Button
          type="PRIMARY"
          size="BIG"
          onClick={() => onSubmit(offerDetail.id, offerDetail.bidding_id)}
          /* disabled={!isDocumentChecked} */
          disabled={!freeResources}
        >
          <FormattedMessage id="global_buy" defaultMessage={dlt['global_buy']} />
        </Button>
      </div>
    </BuyModalSC>
  );
};

const mapStateToProps = (state) => {
  return {
    balance: state.dashboard.balance,
  };
};

export default injectIntl(connect(mapStateToProps)(BuyModal));
